




import { Component, Prop, Vue } from "vue-property-decorator";

import { ServiceMenuStatus } from "@/consts/const";

const CssStatusClassMap: { [key in ServiceMenuStatus]: string } = {
  [ServiceMenuStatus.Ok]: "ok",
  [ServiceMenuStatus.Warning]: "warning",
  [ServiceMenuStatus.Error]: "error",
  [ServiceMenuStatus.Notification]: "notification",
  [ServiceMenuStatus.Maintenance]: "maintenance",
};

@Component({})
export default class ServiceMenuStatusIconWithLink extends Vue {
  @Prop({ required: true }) private status!: ServiceMenuStatus;

  private get cssClass(): { [key: string]: boolean } {
    return {
      [`service-menu-status-icon--${CssStatusClassMap[this.status]}`]: true,
    };
  }
}
